<template>
  <div>
    <div align="left">
      <el-button type="primary" icon="el-icon-circle-plus">增加新用户</el-button>
    </div>


    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="acc"
        label="账号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="100">
      </el-table-column>

      <el-table-column
        prop="company"
        label="所属企业"
        width="150">
      </el-table-column>
      <!--<el-table-column-->
      <!--prop="terminals"-->
      <!--label="可用投放设备"-->
      <!--width="220">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="role"
        label="角色"
        width="100">
      </el-table-column>
      <el-table-column
        prop="loginTime"
        label="最后登陆"
        width="140">
      </el-table-column>
      <el-table-column
        prop="loginIp"
        label="最后登陆IP"
        width="130">
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址"
        width="300">
      </el-table-column>


      <el-table-column
        prop="regTime"
        label="注册时间"
        width="100">
      </el-table-column>
      <el-table-column
        prop="regIp"
        label="注册IP"
        width="130">
      </el-table-column>

      <el-table-column
        prop="phone"
        label="电话"
        width="110">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">

          <el-button
            @click.native.prevent="modifyPwd(scope.$index, tableData)"
            type="primary"
            size="mini">
            修改密码
          </el-button>
          <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            size="mini" :type="tableData[scope.$index].enable==1?'danger':'success'" >
            {{tableData[scope.$index].enable==1?"停用":"启用"}}
          </el-button>

        </template>
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
  export default {
    methods: {
      modifyPwd(index,rows){

      },
      deleteRow(index, rows) {
        //rows.splice(index, 1);
        rows[index].enable=!rows[index].enable;
      }
    },
    data() {
      return {
        tableData: [{
          acc:"admin",
          name:"管理员",
          phone:"18888888888",
          company:"乐山市城开司",
          address:"乐山市城开司",
          role:"管理员",
          loginTime: '2016-05-03 12:52',
          loginIp:"255.255.255.255",
          regTime: '2016-05-03',
          regIp:"0.0.0.0",
          terminals:"1号回收站",
          enable:true
        }, {
          acc:"admin",
          name:"管理员",
          phone:"18888888888",
          company:"乐山市城开司",
          address:"乐山市城开司",
          role:"管理员",
          loginTime: '2016-05-03',
          loginIp:"0.0.0.0",
          regTime: '2016-05-03',
          regIp:"0.0.0.0",
          terminals:"1号回收站",
          enable:true
        }]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/mwSearch.vue